import axios from "axios";

/**
 * Dedicated axios instance for the fiscal server (e.g. fiscal device / local PHP backend).
 * Base URL: http://127.0.0.1:8000
 */
const fiscalApi = axios.create({
	baseURL: "http://192.168.0.254:8000",
	headers: {
		Accept: "application/json",
		"Content-Type": "application/json;charset=utf-8",
	},
	timeout: 60000,
});

export default fiscalApi;
